import $ from 'jquery';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  // tab, shift, alt, ctrl or arrow keys

  const metaKeys = (keyCode) => [9, 16, 17, 18, 37, 38, 39, 40].includes(keyCode);

  class AppAndEditor {
    static initialize() {
      // additional way of creating jQuery modals when we do not need .modal div wrapper (as it's already included in the partial)
      $(document).on('click.modal', 'a[rel~="modal:ajax-open"]', (e) => {
        $.ajax({
          url: $(e.currentTarget).attr('href'),
          success(newHTML) {
            $(newHTML).appendTo('body').modal();
          },
        });

        return false;
      });

      $(document).on('click.modal', 'a[rel~="modal:iframe-open"]', (e) => {
        const $target = $(e.currentTarget);
        const $modal = $('<div class="modal modal--iframe-open" />');
        const $modalBody = $('<div class="modal__preview" />');
        const $modalBodyIframe = $('<iframe class="modal__preview-iframe" />');
        const url = $target.attr('href');

        $modalBodyIframe.attr('src', url);
        $modalBodyIframe.appendTo($modalBody);
        $modalBody.appendTo($modal);
        $modal.appendTo('body').modal();

        // Resize iframe to fit content
        if ($target.data('fit-content') === 'yes') {
          $modalBodyIframe.on('load', () => {
            $modalBodyIframe.css('height', $modalBodyIframe.contents().height());
          });
        }

        return false;
      });

      $(document).on($.modal.CLOSE, (_, modal) => {
        const $modal = $(modal.elm);

        if ($modal.hasClass('modal--iframe-open')) {
          $modal.remove();
        }
      });

      $(document).on($.modal.OPEN, (_, modal) => {
        const $modal = $(modal.elm);
        $('.jquery-modal').css({ opacity: 1 });
        $modal.find('input[autofocus]').trigger('focus');
      });

      $(document).on(
        'change keyup paste input',
        '.field--shoppable-unit-price, .field--shoppable-markup, .field--shoppable-client-price',
        (e) => {
          if (metaKeys(e.keyCode)) {
            return;
          }

          const $field = $(e.target);
          const $form = $field.closest('.bookmarklet-form');
          const $unitPriceField = $form.find('.field--shoppable-unit-price');
          const $markupField = $form.find('.field--shoppable-markup');
          const $clientPriceField = $form.find('.field--shoppable-client-price');

          const unitPriceCents = parseFloat($unitPriceField.val()) * 100 || 0;

          let clientPriceCents;
          // when modifying client price field - calculate and set markup
          if ($field.is('.field--shoppable-client-price')) {
            clientPriceCents = parseFloat($field.val()) * 100 || 0;

            if (unitPriceCents <= clientPriceCents && unitPriceCents > 0) {
              const markupPercentage = (clientPriceCents - unitPriceCents) / unitPriceCents;
              $markupField.val((markupPercentage * 100).toFixed(2));
            }
          } else {
            // when modifying unit price or markup - calculate and set client price
            const markupPercentage = parseFloat($markupField.val()).toFixed(2) / 100 || 0;
            clientPriceCents = unitPriceCents + unitPriceCents * markupPercentage;

            $clientPriceField.val((clientPriceCents / 100).toFixed(2));
          }

          if (unitPriceCents > clientPriceCents) {
            $clientPriceField.addClass('field--error');
            $form.find('.error-message--price').show();
            $form.find('button').attr('disabled', true);
          } else {
            $clientPriceField.removeClass('field--error');
            $form.find('.error-message--price').hide();
            $form.find('button').attr('disabled', false);
          }
        }
      );

      $(document).on('click', '.d-button--confirm-delete-my-asset', (e) => {
        e.preventDefault();
        const id = e.currentTarget.dataset.id;
        const url = '/items/' + id;
        $.ajax({
          url,
          type: 'DELETE',
        }).done(() => {
          $('.modal--delete-confirmation').find('a.close-modal').click();

          document.dispatchEvent(new CustomEvent('items:updated', { detail: { kind: 'asset' } }));
        });
      });
    }
  }

  // upload item - project dropdown
  $(document).on('click', '.projects-dropdown__label-text', () => {
    if ($('.projects-dropdown__dropdown:visible').length) {
      $('.projects-dropdown__dropdown').hide();
    } else {
      $('.projects-dropdown__dropdown').slideDown('fast', () => {
        $('.field--projects-dropdown-search').focus();
      });
    }
  });

  $(document).on('click', '.dropdown-button__item--delete-my-asset', (e) => {
    const $trigger = $(e.currentTarget);
    const $thumb = $trigger.closest('[data-controller="moodboard--assets--thumb"]');
    const imageSrc = $thumb.find('img').first().attr('src') || '';
    $('.js-delete-asset-image').attr('src', imageSrc);
    $('#modal--delete-my-asset-confirmation').modal();
    $('.d-button--confirm-delete-my-asset').attr('data-id', e.currentTarget.dataset.id);
    $('.d-button--confirm-delete-my-asset').attr('data-item-type', 'my-asset');
    return false;
  });

  $(document).on('change', '.projects-dropdown input[type="checkbox"]', () => {
    let val = $('.projects-dropdown :checked')
      .map(function () {
        return $(this).data().title;
      })
      .get()
      .join(', ');
    if (val === '') {
      val = 'Please select project';
    }

    $('.projects-dropdown__label-text').html(val);
  });

  $(function () {
    $('.modal--first-time-in-editor').modal();
  });

  $(document).on($.modal.OPEN, '.modal--vendor-form', () => {
    if (document.querySelector('.autocomplete-company-name')) {
      const renderItem = (ul, item) => {
        return $('<li>').append(`<div>${item.label}</div>`).appendTo(ul);
      };

      $('.autocomplete-company-name')
        .autocomplete({
          source(request, response) {
            $.ajax({
              url: '/vendors/xhr_company_names',
              data: { q: request.term },
              success(data) {
                response(data);
              },
            });
          },
          minLength: 2,
          select(event, ui) {
            const form = event.target.form;
            const button = document.querySelector(
              '#modal--existing-vendor-confirmation a[rel="modal:ajax-open"]'
            );

            document.querySelector('.js-existing-vendor').textContent = `'${ui.item.value}'`;
            $('#modal--existing-vendor-confirmation').modal();

            if (form.matches('.vendors-form--billable')) {
              const kind = 'billable';
              const billableItemIds = form.elements.billable_item_ids.value;
              button.href = `/vendors/${ui.item.id}/edit?kind=${kind}&billable_item_ids=${billableItemIds}`;
            } else {
              button.href = `/vendors/${ui.item.id}/edit`;
            }
          },
        })
        .autocomplete('instance')._renderItem = renderItem;
    }
  });

  $(document).on($.modal.AFTER_CLOSE, '.modal--vendor-form', () => {
    $('.autocomplete-company-name').autocomplete('destroy');
    $('.ui-autocomplete').remove();

    $('.modal--vendor-form').remove();
  });

  $('html').click(function (e) {
    const $target = $(e.target);
    if (
      !$target.is('.projects-dropdown__dropdown *') &&
      !$target.is('.projects-dropdown__label-text')
    ) {
      $('.projects-dropdown__dropdown').hide();
    }
  });

  AppAndEditor.initialize();
});
